import {
  Group,
  Id,
  Identifiable,
  ProjectResource,
  Resource,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function getProjectResourceGroup(httpClient: HttpClient, linker: Linker) {
  return (groupId: Id) =>
    httpClient
      .sendHttpRequest<
        LinkedResource<Identifiable<Group<Identifiable<ProjectResource>>>>
      >({
        endpoint: `/projectResourceGroups/${groupId}`,
        method: HttpMethods.GET,
      })
      .then(linker.linkProjectResourceGroup);
}

function getPlanzoneResourceGroup(httpClient: HttpClient, linker: Linker) {
  return (groupId: Id) =>
    httpClient
      .sendHttpRequest<
        LinkedResource<Identifiable<Group<Identifiable<Resource>>>>
      >({
        endpoint: `/planzoneResourceGroups/${groupId}`,
        method: HttpMethods.GET,
      })
      .then(linker.linkPlanzoneResourceGroup);
}

function getResourceGroup(httpClient: HttpClient, linker: Linker) {
  return (resourceType: string, groupId: Id) =>
    resourceType === "project"
      ? getProjectResourceGroup(httpClient, linker)(groupId)
      : getPlanzoneResourceGroup(httpClient, linker)(groupId);
}

export { getResourceGroup };
